<template>
  <span>
    <k-button
      btn-text="生成报告"
      :auth-type="false"
      type="primary"
      plain
      icon="iconfont icon-baogao"
      :loading="loading"
      :disabled="busy"
      @click="generate"
    />
    <k-button
      btn-text="生成临时报告"
      :auth-type="false"
      type="primary"
      plain
      icon="iconfont icon-baogao"
      :loading="loading"
      :disabled="busy"
      @click="preview"
    />

    <el-dialog
      v-if="missingDialogVisible"
      class="o-dialog o-dialog--md"
      :title="`暂不能生成${reportName}`"
      :visible.sync="missingDialogVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-alert
        :title="`${projectName || '当前项目'}仍有报告阻断项，请先处理后再生成${reportName}。`"
        type="warning"
        :closable="false"
        show-icon
      />
      <k-table
        class="jx-pg-report-preview__missing"
        :table-column="missingColumns"
        :data="missingGroups"
        :pagination-show="false"
      />
      <div
        slot="footer"
        class="o-dialog__footer"
      >
        <k-button
          btn-text="关闭"
          :auth-type="false"
          @click="missingDialogVisible = false"
        />
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { pgReportService } from './report.service';

export default {
  name: 'JxxfPgReportPreviewButton',
  props: {
    projectId: {
      type: String,
      required: true
    },
    projectName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      confirming: false,
      missingDialogVisible: false,
      reportName: '临时报告',
      missingGroups: [],
      missingColumns: [
        { key: 'index', label: '序号', width: '65', align: 'center', type: 'index' },
        { key: 'groupName', label: '阻断项', minWidth: '180', align: 'left', type: 'text' },
        { key: 'count', label: '数量', width: '80', align: 'center', type: 'text' },
        { key: 'message', label: '处理提示', minWidth: '320', align: 'left', type: 'text' }
      ]
    };
  },
  computed: {
    busy () {
      return this.loading || this.confirming;
    }
  },
  methods: {
    generate () {
      if (this.busy) return;
      this.confirming = true;
      this.$confirm('是否确认生成报告？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.generateReport('报告', pgReportService.generate, true);
      }).catch(() => {}).finally(() => {
        this.confirming = false;
      });
    },
    preview () {
      if (this.busy) return;
      this.generateReport('临时报告', pgReportService.preview, false);
    },
    generateReport (reportName, generateApi, official) {
      this.reportName = reportName;
      this.missingGroups = [];
      this.missingDialogVisible = false;
      this.loading = true;
      pgReportService.prepare(this.projectId).then(rsp => {
        const prepared = rsp.data || {};
        this.missingGroups = prepared.missingGroups || [];
        if (this.missingGroups.length) {
          this.missingDialogVisible = true;
          return null;
        }
        return generateApi(this.projectId).then(generateRsp => {
          const result = (generateRsp.data || {}).data || {};
          this.$message.success(official ? '正式报告已生成，项目已完成' : `${reportName}已生成`);
          if (official) {
            this.$emit('report-generated', result);
          }
          return this.openFileId(result.wjId);
        });
      }).catch(() => {
        this.$message.error(`${reportName}生成失败，请稍后重试`);
      }).finally(() => {
        this.loading = false;
      });
    },
    openFileId (fileId) {
      if (!fileId) {
        this.$message.warning(`${this.reportName}文件不存在`);
        return Promise.resolve();
      }
      return this.$axios.get(`${this.$config.fileApi.initDownload}/${fileId}`).then(rsp => {
        const path = rsp.data && rsp.data.data;
        if (!path) {
          this.$message.warning(`${this.reportName}文件不存在`);
          return null;
        }
        return this.$axios.get(`${this.$config.fileApi.download}/${path}`, { responseType: 'blob' });
      }).then(rsp => {
        if (!rsp || !rsp.data) return;
        const url = URL.createObjectURL(new Blob([rsp.data], { type: 'application/pdf' }));
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      }).catch(() => {
        this.$message.warning(`${this.reportName}文件暂不可用，请稍后重试`);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.jx-pg-report-preview__missing {
  margin-top: 16px;
}
</style>
